import api from './AxiosInstance';

export class GestionPretsService {

  putpret = async (payload) => {
    try {
      const response = await api.put(`Paie/Pret/stopped`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updateEcheance = async (payload) => {
    try {
      const response = await api.post(`/Paie/Pret/Echeance/list`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addEcheance = async (payload) => {
    try {
      const response = await api.post(`/Paie/Pret/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllTypePret = async () => {
    try {
      const response = await api.get(`/Paie/Pret/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getDetailPret = async (matrisal, code) => {
    try {
      const response = await api.get(`/Paie/Pret/Echeance/Salarie/list?matri=${matrisal}&code=${code}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  deletePret = async (code) => {
    try {
      const response = await api.delete(`/Paie/Pret/delete/${code}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };




}